import { SearchOutlined } from "@ant-design/icons";
import { Button, Input, Select } from "antd";
import React from "react";
import { SearchConfig } from "../../../types/search";
import { SelectOption } from "../../../types/select";
import { useSearchField } from "./useSearchField";

type SearchBarProps = {
  searchByOptions: SearchConfig[];
  selectOptions?: SelectOption[];
  defaultSearch?: string;
  onChangeSearchBy: (option: SearchConfig) => void;
  onSearch: (value: string) => void;
  searchByPlaceholder?: string;
  searchInputPlaceholder?: string;
  selectSearchPlaceholder?: string;
};

export const SearchBar = (props: SearchBarProps) => {
  const {
    searchByOptions,
    selectOptions,
    defaultSearch,
    onChangeSearchBy,
    onSearch,
    searchByPlaceholder = "Select an option...",
    searchInputPlaceholder = "Search...",
    selectSearchPlaceholder = "Select an option...",
  } = props;

  const { isSelectSearch, selectedSearchByOption, handleSearchByChange, handleSearch } = useSearchField({
    searchByOptions,
    onChangeSearchBy,
    onSearch,
  });

  const SearchByDropdown = () => {
    if (!searchByOptions?.length) return null;
    return (
      <Select
        className={isSelectSearch ? "custom-select" : ""}
        value={selectedSearchByOption}
        labelInValue
        placeholder={searchByPlaceholder}
        style={{
          minWidth: "10rem",
          textAlign: "left",
          backgroundColor: "#f0f2f5",
        }}
        onChange={handleSearchByChange}
        size="large"
        dropdownMatchSelectWidth={false}
        options={searchByOptions}
        bordered={false}
      />
    );
  };

  const SearchInput = (
    <Input.Search
      key={defaultSearch + selectedSearchByOption}
      addonBefore={SearchByDropdown()}
      className="org_search"
      placeholder={searchInputPlaceholder}
      enterButton
      defaultValue={defaultSearch ?? ""}
      bordered={false}
      size="large"
      allowClear
      onSearch={handleSearch}
    />
  );

  const SelectSearch = (
    <Input.Group compact style={{ display: "flex", width: "100%" }}>
      {SearchByDropdown()}
      <Select
        key={defaultSearch + selectedSearchByOption}
        style={{ background: "#fff", flex: 1 }}
        placeholder={selectSearchPlaceholder}
        size="large"
        allowClear
        defaultValue={defaultSearch || "All"}
        bordered={false}
        onChange={handleSearch}
        options={selectOptions}
      />
      <Button
        disabled
        type="primary"
        icon={<SearchOutlined style={{ fontSize: "1rem" }} />}
        size="large"
        style={{
          borderTopRightRadius: "0.375rem",
          borderBottomRightRadius: "0.375rem",
          height: "2.5rem",
          width: "3rem",
        }}
      />
    </Input.Group>
  );

  return isSelectSearch ? SelectSearch : SearchInput;
};
